import { extractJsonFieldSql } from './extractJsonFieldSql';

export function buildWhereByShoppingCenter(
    rawName: string,
    shoppingCenter: string,
    field = 'attributes',
): [string, string[]] {
    if (shoppingCenter.length === 0) {
        return ['', []];
    }
    const fieldName = extractJsonFieldSql(field, `$.2778.${rawName}`);
    const isCompetitor = extractJsonFieldSql(field, `$.7614.${rawName}`);
    return [
        `(${isCompetitor} = '["1"]' OR ${fieldName} like ?)`,
        [`%%${JSON.stringify(shoppingCenter)}%%`]
    ];
}
